import {
    BasicPageSchema,
    LearnMoreSchema,
    ChapterSchema,
    TimelineYearsSchema,
} from '@/schemas/thesaurusSchema';
import { useDedaloApi } from './useDedaloApi';
import { EXPO_CONFIG } from '@/api/expoConfig.js';

export function useBasicPage(id) {
    const options = {
        table: EXPO_CONFIG.table,
        section_id: id,
        ar_fields: ['title', 'abstract', 'body'],
    };

    return useDedaloApi(options, BasicPageSchema);
}

export function useLearnMore(id) {
    const options = {
        table: EXPO_CONFIG.table,
        section_id: id,
        ar_fields: ['title', 'abstract', 'body', 'uri', 'bibliography_data'],
        resolve_portals_custom: '{"bibliography_data": "bibliographic_references"}',
    };

    return useDedaloApi(options, LearnMoreSchema);
}

export function useChapter(id) {
    const options = {
        table: EXPO_CONFIG.table,
        section_id: id,
        ar_fields: [
            'title',
            'abstract',
            'body',
            'image',
            'other_images',
            'audiovisual',
            'indexations',
            'pdf_data',
        ],
        resolve_portals_custom:
            '{"image": "image", "other_images": "image", "audiovisual": "audiovisual", "pdf_data": "document"}',
    };

    return useDedaloApi(options, ChapterSchema);
}

export function useTimelineChildren() {
    const options = {
        table: EXPO_CONFIG.table,
        sql_filter: `parent = "${EXPO_CONFIG.tld}_${EXPO_CONFIG.specialPages.timeline}"`,
        ar_fields: ['title', 'term', 'abstract', 'related'],
    };

    return useDedaloApi(options, TimelineYearsSchema);
}
